import { apiRequestTypes, API_ERROR_MESSAGES } from "../../constants/service";
import { useToastStore } from "../../store/toast/store";

export const removeSearchAllMLSFlag = criteriaObj => {
    criteriaObj.criteria?.realEstateDatasourceIdsWithFilters?.forEach(mls => {
        delete mls.searchAllMLS;
    });
    return criteriaObj;
};

export const getPostRequestObj = (url, token, data = undefined, activeClientId) => {
    const activeClientIdHeader = activeClientId ? ({
        'Lwt-Active-Client-Id': activeClientId
    }) : {};
    return new Request(url, {
        method: apiRequestTypes.post,
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            ...activeClientIdHeader,
        }),
        mode: 'cors',
        cache: 'default',
        body: data ? JSON.stringify(data) : ''
    });

};

export const getGetRequestObj = (url, token, queryString = undefined, activeClientId) => {
    const requestUrl = queryString ? `${url}?${queryString}` : url;
    const activeClientIdHeader = activeClientId ? ({
        'Lwt-Active-Client-Id': activeClientId
    }) : {};
    return new Request(requestUrl, {
        method: apiRequestTypes.get,
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            ...activeClientIdHeader,
        }),
        mode: 'cors',
        cache: 'no-store'
    });
};

export const getDeleteRequestObj = (url, token, queryString = undefined) => {
    const requestUrl = queryString ? `${url}?${queryString}` : url;
    return new Request(requestUrl, {
        method: apiRequestTypes.delete,
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }),
        mode: 'cors'
    });
};

export const getPutRequestObj = (url, token, data) => {

    return new Request(url, {
        method: apiRequestTypes.put,
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }),
        mode: 'cors',
        body: JSON.stringify(data)
    });
};

export const getPostRequestObjNoToken = (url, data) => {
    return new Request(url, {
        method: apiRequestTypes.post,
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded',
        }),
        mode: 'cors',
        cache: 'default',
        body: data
    });
};

export const getRequestObjectByMethodType = ({
    url,
    token,
    activeClientId,
    data,
    queryString,
}) => Object.freeze({
    [apiRequestTypes.post]: getPostRequestObj(
        url,
        token,
        data,
        activeClientId
    ),
    [apiRequestTypes.get]: getGetRequestObj(
        url,
        token,
        queryString,
        activeClientId
    ),
});

export const handleApiError = ({ response, endpoint, customErrorMessage = null, suppressToast = false }) => {
    if ((response.status === 400 || response.status === 500) && !suppressToast) {
        const message = customErrorMessage || API_ERROR_MESSAGES[response.status];

        useToastStore.getState().showToast(message, 'error');
        console.error('[API Error]', {
            endpoint,
            status: response.status,
            statusText: response.statusText,
            timestamp: new Date().toISOString()
        });
    }
};
